import React, { Component } from 'react';
import PropTypes, {
  arrayOf, number, func, shape, string,
} from 'prop-types';
import { Button } from 'components/common';

import './YearButtonFilter.scss';

class YearButtonsFilter extends Component {
  selectedYear = (year, idx) => () => {
    const { onYearSelection } = this.props;
    if (onYearSelection) {
      onYearSelection(year, idx);
    }
  };

  render() {
    const { yearButtonFilter, btnContent } = this.props;
    const { yearButtonCount, activeYearButtonIdx } = yearButtonFilter;

    return (
      <div className="year-button-section year-nav">
        <div className="row-btn-wrapper">
          {
            yearButtonCount.map((i) => {
              const active = activeYearButtonIdx === i;
              return (
                <div className="col-btn-wrapper" key={i}>
                  <Button
                    noMinWidth
                    small
                    tertiary={!active}
                    onClick={this.selectedYear(new Date().getFullYear() - i, i)}
                  >
                    {i === 2 ? `${new Date().getFullYear() - i} ${btnContent}`
                      : new Date().getFullYear() - i}
                  </Button>
                </div>
              );
            })
          }
        </div>
      </div>
    );
  }
}

YearButtonsFilter.propTypes = {
  yearButtonFilter: shape({
    yearButtonCount: arrayOf(PropTypes.number),
    activeYearButtonIdx: number,
  }),
  onYearSelection: func,
  btnContent: string,
};

YearButtonsFilter.defaultProps = {
  onYearSelection: null,
  yearButtonFilter: null,
  btnContent: null,
};

export default YearButtonsFilter;
